import i18next from 'i18next';
import { blue, blueGrey, brown, indigo, lime, pink, purple, teal } from '@mui/material/colors';

export const TEMPLATE_TYPE = {
  STANDARD: 'standard',
  CUSTOM: 'custom'
}

export const LOGO_TYPE= {
  IMAGE: "image",
  TEXTE: "texte",
}

export const COLOR_TYPE = {
  PALETTE: 'palette',
  CUSTOM: 'custom'
}

export const PERSONALIZATION_INPUT_TYPE = {
  LOGO: "logo",
  TEXT: "texte",
  COLOR: "color",
  SELECT: "select",
  PALETTE: "palette",
}

// TODO en attendant de régler le soucis des poids de police non correctement récupéré
export const FONT_WEIGHT_LIST = [
  300,
  400,
  // 500,
  600,
  // 700,
  // 800,
  // 900
]

export const logoInput = {
  image: [
    {
      title: i18next.t("personalization.appearanceTab.logo.downloadLogo"),
      notice: i18next.t("personalization.appearanceTab.logo.downloadLogoNotice"),
      type: PERSONALIZATION_INPUT_TYPE.LOGO,
      fieldName: "logoURI",
    },
    // TODO Cette partie est à décommenté si on met en place les logos sur page login
    // {
    //   title: i18next.t("personalization.appearanceTab.logo.downloadReverseLogo"),
    //   notice: i18next.t("personalization.appearanceTab.logo.downloadLogoNotice"),
    //   type: PERSONALIZATION_INPUT_TYPE.LOGO,
    //   fieldName: "reverseLogoURI"
    // }
  ],
  texte: [
    {
      title: i18next.t("personalization.appearanceTab.logo.logoTexte"),
      notice: i18next.t("personalization.appearanceTab.logo.textLogoNotice"),
      placeholder: i18next.t("personalization.appearanceTab.logo.logoTextePlaceholder"),
      type: PERSONALIZATION_INPUT_TYPE.TEXT,
      fieldName: "logoText"
    },
    {
      title: i18next.t("personalization.appearanceTab.logo.fontWeight"),
      notice: i18next.t("personalization.appearanceTab.logo.fontWeightNotice"),
      placeholder: i18next.t("personalization.appearanceTab.logo.fontWeightPlaceholder"),
      type: PERSONALIZATION_INPUT_TYPE.SELECT,
      fieldName: "logoFontWeight"
    },
    {
      title: i18next.t("personalization.appearanceTab.logo.colorLogo"),
      notice: i18next.t("personalization.appearanceTab.logo.colorLogoNotice"),
      placeholder: i18next.t("personalization.appearanceTab.logo.colorLogoPlaceholder"),
      type: PERSONALIZATION_INPUT_TYPE.COLOR,
      fieldName: "logoColor"
    }
  ]
}

export const colorInput = {
  palette: [
    {
      type: PERSONALIZATION_INPUT_TYPE.PALETTE
    }
  ],
  custom: [
    {
      title: i18next.t("personalization.appearanceTab.color.primaryColor"),
      notice: i18next.t("personalization.appearanceTab.color.primaryColorNotice"),
      placeholder: i18next.t("personalization.appearanceTab.color.colorPlaceholder"),
      type: PERSONALIZATION_INPUT_TYPE.COLOR,
      fieldName: "colorPrimary"
    },
    {
      title: i18next.t("personalization.appearanceTab.color.hoverColor"),
      notice: i18next.t("personalization.appearanceTab.color.hoverColorNotice"),
      placeholder: i18next.t("personalization.appearanceTab.color.colorPlaceholder"),
      type: PERSONALIZATION_INPUT_TYPE.COLOR,
      fieldName: "colorHover"
    },
    {
      title: i18next.t("personalization.appearanceTab.color.backgroundColor"),
      notice: i18next.t("personalization.appearanceTab.color.backgroundColorNotice"),
      placeholder: i18next.t("personalization.appearanceTab.color.colorPlaceholder"),
      type: PERSONALIZATION_INPUT_TYPE.COLOR,
      fieldName: "colorBackground"
    }
  ]
}

// Ne pas changer les noms des palettes ! (ajouter au besoin ou modifier les couleurs)
export const PALETTE_COLORS = [
  {
    name: "aprovall",
    50:  "#EFFBF1",
    100: "#F6F9F3",
    200: "#D7F4DC",
    300: "#CEF4C3",
    400: "#60D273",
    500: "#54CC54",
    600: "#2D9F40",
    700: "#227730",
    800: "#32614F",
    900: "#18260D",
  },
  {
    name: "lime",
    50: lime[50],
    100: lime[100],
    200: lime[200],
    300: lime[300],
    400: lime[400],
    500: lime[500],
    600: lime[600],
    700: lime[700],
    800: lime[800],
    900: lime[900],
  },
  {
    name: "indigo",
    50: indigo[50],
    100: indigo[100],
    200: indigo[200],
    300: indigo[300],
    400: indigo[400],
    500: indigo[500],
    600: indigo[600],
    700: indigo[700],
    800: indigo[800],
    900: indigo[900],
  },
  {
    name: "blue",
    50: blue[50],
    100: blue[100],
    200: blue[200],
    300: blue[300],
    400: blue[400],
    500: blue[500],
    600: blue[600],
    700: blue[700],
    800: blue[800],
    900: blue[900],
  },
  {
    name: "teal",
    50: teal[50],
    100: teal[100],
    200: teal[200],
    300: teal[300],
    400: teal[400],
    500: teal[500],
    600: teal[600],
    700: teal[700],
    800: teal[800],
    900: teal[900],
  },
  {
    name: "purple",
    50: purple[50],
    100: purple[100],
    200: purple[200],
    300: purple[300],
    400: purple[400],
    500: purple[500],
    600: purple[600],
    700: purple[700],
    800: purple[800],
    900: purple[900],
  },
  {
    name: "pink",
    50: pink[50],
    100: pink[100],
    200: pink[200],
    300: pink[300],
    400: pink[400],
    500: pink[500],
    600: pink[600],
    700: pink[700],
    800: pink[800],
    900: pink[900],
  },
  {
    name: "brown",
    50: brown[50],
    100: brown[100],
    200: brown[200],
    300: brown[300],
    400: brown[400],
    500: brown[500],
    600: brown[600],
    700: brown[700],
    800: brown[800],
    900: brown[900],
  },
  {
    name: "blueGrey",
    50: blueGrey[50],
    100: blueGrey[100],
    200: blueGrey[200],
    300: blueGrey[300],
    400: blueGrey[400],
    500: blueGrey[500],
    600: blueGrey[600],
    700: blueGrey[700],
    800: blueGrey[800],
    900: blueGrey[900],
  },
]